import React from "react";
import { Card, NewsInfo, NewsInfoItem, NewsInfoItemText } from "./styled";
import {
    CalendarOutlined,
    TagOutlined,
} from '@ant-design/icons';
import { Link } from "../../Link";

interface NewsCardProps {
    title: string;
    content?: React.ReactNode;
    cover: string;
    date?: string;
    category?: string;
    url: string;
    loading?: boolean;
}

const { Meta } = Card;

export const NewsCard: React.FC<NewsCardProps> = ({
    title,
    cover,
    content,
    date,
    category,
    url,
    loading
}) => {
    let coverImage = null;

    if (cover) {
        coverImage = (
            <div className="w-full h-[190px] overflow-clip scale-105">
                <img
                    alt={title}
                    src={cover}
                    className="w-full h-full hover:scale-105 hover:translate-y-2 transition-all duration-1000 object-cover object-top"
                />
            </div>
        );
    }

    let contentElement = null;

    if (content) {
        contentElement = (
            <div className="flex flex-col h-full justify-between pb-8 text-sky-950">
                {content}
            </div>
        );
    }

    return (
        <Link to={url} className="hover:no-underline" title="Читать">
            <Card
                cover={coverImage}
                hoverable
                //onClick={() => window.location.assign(url)}
                loading={loading}
                className={content ? '' : '!h-[330px]'}
            //className="hover:scale-105 transition-all duration-500"
            >
                <Meta
                    title={<div className="max-w-full text-wrap text-slate-950">{title}</div>}
                    description={contentElement}
                    className="h-full"
                />
                <NewsInfo>
                    <NewsInfoItem>
                        <CalendarOutlined />
                        <NewsInfoItemText>
                            {date}
                        </NewsInfoItemText>
                    </NewsInfoItem>
                    {!!category && <NewsInfoItem>
                        <TagOutlined />
                        <NewsInfoItemText>
                            {category}
                        </NewsInfoItemText>
                    </NewsInfoItem>}
                </NewsInfo>
            </Card>
        </Link>
    );
}

export const LoadingNewsCard = () => (
    <Card
        //cover={coverImage}
        hoverable
        //onClick={() => window.location.assign(url)}
        loading={true}
        className='!h-[330px]'
    //className="hover:scale-105 transition-all duration-500"
    />
)